(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryDialogController', EventCategoryDialogController);

    EventCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventCategory'];

    function EventCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventCategory) {
        var vm = this;
        vm.eventCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventCategory.id !== null) {
                EventCategory.update(vm.eventCategory, onSaveSuccess, onSaveError);
            } else {
                EventCategory.save(vm.eventCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
